import React from "react";

import VandorDetailsSquare from "./VandorDetailsSquare";

const VandorDetailsSquareList = () => {
  const VandorDetailsListArr = [
    {
      vandor_details_img: "/images/vandorDetails/vandorDetails1.jpg",
      title_p_text: "נעליים",
      title_h6_text: "קופסה פשוטה 3",
      title_span_text: "15$",
      image_content_text: "45%",
      link: "/productdetails",
    },
    {
      vandor_details_img: "/images/vandorDetails/vandorDetails2.jpg",
      title_p_text: "מחשבי נייד",
      title_h6_text: "קופסה פשוטה 3",
      title_span_text: "15$",
      image_content_text: "45%",
      link: "/productdetails",
    },
    {
      vandor_details_img: "/images/vandorDetails/vandorDetails3.jpg",
      title_p_text: "חולצות",
      title_h6_text: "קופסה פשוטה 3",
      title_span_text: "15$",
      image_content_text: "45%",
      link: "/productdetails",
    },
    {
      vandor_details_img: "/images/vandorDetails/vandorDetails4.jpg",
      title_p_text: "אייפד",
      title_h6_text: "קופסה פשוטה 3",
      title_span_text: "75$",
      image_content_text: "45%",
      link: "/productdetails",
    },
    {
      vandor_details_img: "/images/vandorDetails/vandorDetails5.jpg",
      title_p_text: "פייר קרדן",
      title_h6_text: "קופסה פשוטה 3",
      title_span_text: "99$",
      image_content_text: "45%",
      link: "/productdetails",
    },
    {
      vandor_details_img: "/images/vandorDetails/vandorDetails6.jpg",
      title_p_text: "פלאפון",
      title_h6_text: "קופסה פשוטה 3",
      title_span_text: "10$",
      image_content_text: "45%",
      link: "/productdetails",
    },
    {
      vandor_details_img: "/images/vandorDetails/vandorDetails7.jpg",
      title_p_text: "נעליים",
      title_h6_text: "קופסה פשוטה 3",
      title_span_text: "15$",
      image_content_text: "45%",
      link: "/productdetails",
    },
    {
      vandor_details_img: "/images/vandorDetails/vandorDetails8.jpg",
      title_p_text: "חולצות מכופתרות",
      title_h6_text: "קופסה פשוטה 3",
      title_span_text: "15$",
      image_content_text: "45%",
      link: "/productdetails",
    },
  ];

  return (
    <div className="list_box_area row gx-4">
      {VandorDetailsListArr.map((el, i) => {
        return (
          <VandorDetailsSquare key={i}
            vandor_details_img={el.vandor_details_img}
            title_p_text={el.title_p_text}
            title_h6_text={el.title_h6_text}
            title_span_text={el.title_span_text}
            image_content_text={el.image_content_text}
            link={el.link}
          />
        );
      })}
    </div>
  );
};

export default VandorDetailsSquareList;
